<template>
  <nav class="Menu">
    <teleport to="body">
      <transition name="slideBurger">
      <app-contract-modal
          v-if="modal"
          @close="modal = false; scrollLock()">
      </app-contract-modal>
      </transition>
    </teleport>
    <ul class="burgerList">
      <li><router-link to="#"><button class="burgerBtn" @click="modal = true; scrollLock()">Заключить Договор на ТО</button></router-link></li>
      <li><router-link to="/change/changeInformation"><button class="burgerBtn" @click="toggleBurger()">Замена</button></router-link></li>
      <li><router-link to="/montage/copperPipe"><button class="burgerBtn"  @click="toggleBurger()">Монтаж</button></router-link></li>
      <li><router-link to="/repair/repairBoiler"><button class="burgerBtn"  @click="toggleBurger()">Ремонт</button></router-link></li>
      <li><router-link to="/control"><button class="burgerBtn"  @click="toggleBurger()">диагностирование</button></router-link></li>
      <li><router-link to="/service/serviceInformation"><button class="burgerBtn" @click="toggleBurger()">Сервис</button></router-link></li>
      <li><router-link to="/protection"><button class="burgerBtn"  @click="toggleBurger()">Защита (СО)</button></router-link></li>
      <li><router-link to="/documents"><button class="burgerBtn"  @click="toggleBurger()">Документы</button></router-link></li>
      <li><router-link to="/questions"><button class="burgerBtn"  @click="toggleBurger()">F.A.Q.</button></router-link></li>
    </ul>
  </nav>
</template>

<script>

  import {useStore} from 'vuex'
  import AppContractModal from "@/components/AppContractModal";
  import {ref} from "vue";

  export default {
    components: {AppContractModal},

    setup() {
      const store = useStore()

      let modal = ref(false)

      function scrollLock() {
        if (modal.value === true) {
          document.body.style.overflow = "hidden"
        } else {
          document.body.style.overflow = ""
        }
      }

      return {
        toggleBurger: () => {
          store.commit('toggleBurger')
        },
        modal,
        scrollLock
      }
    }
  }
</script>

<style scoped>

.slideBurger-enter-from {
  opacity: 0;
}
.slideBurger-leave-to {
  opacity: 0;
}
.slideBurger-enter-active, .slideBurger-leave-active {
  transition: all 1s;
}

  ul li {
    text-align: center;
    margin: 0 32% 30px 32%;
    border-radius: 20px;
    background-color: bisque;
    list-style: none;
  }

  ul li:hover {
    background-color: #a8d0e6;
    box-shadow: 0 0 70px #374785;
  }

  ul li a {
    font-size: 30px;
    color: #374785;
    text-decoration: none;
    font-weight: 900;
    letter-spacing: 2px;
    line-height: 1.4em;
  }

  ul li a:hover {
    color: black;
  }

  .Menu {
    position: absolute;
    top: 88px;
    width: 100%;
    height: 94vh;
    background-image: url(../img/backside.webp);
    background-size: cover;
    overflow: auto;
  }

  .burgerBtn {
    background: transparent;
    border: none;
    font-weight: 600;
    color: #374785;
    padding: 5px;
    font-size: 1em;
    cursor: pointer;
  }

  .burgerBtn:hover {
    background-color: #a8d0e6;
    color: #111111;
  }

  @media (max-width: 1400px) {

   ul li {
     margin: 0 25% 30px 25%;
   }

   ul li a {
      font-size: 30px;
    }
  }

  @media (max-width: 700px) {
    ul li {
      margin: 0 10% 15px 5%;
    }

    ul li a {
      font-size: 20px;
    }
  }

  @media (max-width: 900px) {
   .Menu {
     top: 66px
   }
  }

  @media (max-height: 600px) {

    ul li a {
      font-size: 20px;
    }

    .Menu {
      height: calc(100vh - 66px);
    }
  }

</style>